import { combineReducers } from 'redux'

import resultados from './detalhesAdiantamentosSuprimentos'
import fornecedores from './fornecedores'

export default combineReducers({ resultados, fornecedores })
